import { Navigate, useRoutes } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setPathName } from "./Components/redux/actions/pathNameActions";
import { useEffect } from "react";
import Profile from "./pages/Finupdate/LinkUsingIFSC";
import UploadDocumentsPageFinUpdate from "./pages/Finupdate/UploadDocumentsPage";
import AccountClosureProfile from "./pages/AccountClosure/AccountClosureProfile";
import AccountClosureEsign from "./pages/AccountClosure/AccountClosureEsign";
import AccountClosureCMRUpload from "./pages/AccountClosure/AccountClosureCMRUpload";
import AccountClosureAddFunds from "./pages/AccountClosure/AccountClosureAddFunds";
import AccountClosureApproved from "./pages/AccountClosure/AccountClosureApproved";
import BankProfileDetails from "./pages/BankUpdate/ProfileDetails";
import UpdateBankDetails from "./pages/BankUpdate/BankDetails";
import BankUpdateEsign from "./pages/BankUpdate/BankUpdateEsign";
import BankUpdationCompleted from "./pages/BankUpdate/BankUpdationCompleted";
import BankUpdateEsignSuccessPage from "./pages/BankUpdate/BankUpdateEsignResponse";
import DDPIProfileDetails from "./pages/DDPI/DDPIProfile/DDPIProfile";
import DDPICompleted from "./pages/DDPI/DDPICompleted/DDPICOmpleted";
import SuccessDDPIEsignPage from "./pages/DDPI/DDPIEsignResponse";
import EmailMobileProfileDetails from "./pages/EmailandMobileUpdate/EmailMobileUpdateProfile/EmailMobileUpdateProfile";
import NomineeUpdateProfileDetails from "./pages/NomineeUpdate/NomineeUpdateProfile/NomineeUpdateProfile";
import NomineesPage from "./pages/NomineePage";
import IPV from "./Components/CameraModule/WebCamFaceDetection";
import EmailandMobileUpdateEsign from "./pages/EmailandMobileUpdate/EmailandMobileEsign/EmailandMobileEsign";
import EmailMobileUpdateEsignSuccessPage from "./pages/EmailandMobileUpdate/EmailMobileUpdateEsignResponse/EmailMobileEsignResponse";
import EmailMobileUpdationCompleted from "./pages/EmailandMobileUpdate/EmailMobileUpdateCompleted/EmailMobileUpdateCompleted";
import LandingPage from "./pages/LandingPage/LandingPage";
import NomineeUpdateEsign from "./pages/NomineeUpdate/NomineeUpdateEsign/NomineeUpdateEsign";
import NomineeEsignSuccessPage from "./pages/NomineeUpdate/NomineeUpdateEsignResponse/NomineeUpdateEsignResponse";
import NomineeUpdationCompleted from "./pages/NomineeUpdate/NomineeUpdateCompleted/NomineeUpdateCompleted";
import SegmentUpdateProfileDetails from "./pages/SegmentUpdate/SegmentUpdateProfile/SegmentUpdateProfile";
import SegmentDetails from "./pages/SegmentUpdate/SegmentDetails/SegmentDetails";
import SegmentUpdateEsign from "./pages/SegmentUpdate/SegmentUpdateEsign/SegmentUpdateEsign";
import SegmentEsignSuccessPage from "./pages/SegmentUpdate/SegmentUpdateEsignResponse/SegmentUpdateEsignResponse";
import SegmentUpdationCompleted from "./pages/SegmentUpdate/SegmentUpdateCompleted/SegmentUpdateCompleted";
import SegmentUploadDocumentsPage from "./pages/SegmentUpdate/SegmentUploadDocument/SegmentUploadDocument";
import NomineeUpdationApproved from "./pages/NomineeUpdate/NomineeUpdateCompleted/NomineeUpdateApproved";
import SegmentUploadIncomeFetchResponse from "./pages/SegmentUpdate/SegmentUploadDocument/SegmentUploadIncomeFetchResponse";
import FinUpdateFetchIncomeResponse from "./pages/Finupdate/FetchIncomeProofFinUpdate";
import FinUpdationCompleted from "./pages/Finupdate/FinUpdateCompleted/FinUpdateCompleted";
import AccountClosureEsignSuccessPage from "./pages/AccountClosure/AccountClosureEsignResponse/AccountClosureEsignResponse";
import EmailMobileUpdationApproved from "./pages/EmailandMobileUpdate/EmailMobileUpdateCompleted/EmailMobileUpdateApproved";
import FinUpdationApproved from "./pages/Finupdate/FinUpdateCompleted/FinUpdateApproved";
import SegmentUpdationApproved from "./pages/SegmentUpdate/SegmentUpdateCompleted/SegmentUpdateApproved";
import PageNotFound from "./pages/PageNotFound";
import DDPIEsign from "./pages/DDPI/DDPIEsign/DDPIEsign";
import AccountClosureSettlement from "./pages/AccountClosure/AccountClosureSettlement/AccountClosureSettlement";

export default function Router() {
  const pathName = useLocation().pathname;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPathName(pathName));
  }, [pathName]);

  const routes = useRoutes([
    {
      path: "",
      element: <LandingPage />,
    },
    //---------------------------------------bankUpdate----------------------------
    {
      path: "bankupdate",
      element: "",
      children: [
        { element: <Navigate to="profile" />, index: true },
        {
          path: `profile`,
          element: <BankProfileDetails />,
        },
        {
          path: `addBank`,
          element: <UpdateBankDetails />,
        },
        {
          path: `esign`,
          element: <BankUpdateEsign />,
        },
        {
          path: `esignResponse/*`,
          element: <BankUpdateEsignSuccessPage />,
        },

        {
          path: `completed`,
          element: <BankUpdationCompleted />,
        },
      ],
    },

    //---------------------------------------Email & Mobile Update----------------------------
    {
      path: "emailandmobileupdate",
      element: "",
      children: [
        { element: <Navigate to="details" />, index: true },
        {
          path: `details`,
          element: <EmailMobileProfileDetails />,
        },
        {
          path: `ipv`,
          element: <IPV />,
        },
        {
          path: `esign`,
          element: <EmailandMobileUpdateEsign />,
        },
        {
          path: `esignResponse/*`,
          element: <EmailMobileUpdateEsignSuccessPage />,
        },
        {
          path: `completed`,
          element: <EmailMobileUpdationCompleted />,
        },
        {
          path: `approved`,
          element: <EmailMobileUpdationApproved />,
        },
      ],
    },
    //---------------------------------------Nominee Update----------------------------
    {
      path: "nomineeUpdate",
      element: "",
      children: [
        { element: <Navigate to="profile" />, index: true },
        {
          path: `profile`,
          element: <NomineeUpdateProfileDetails />,
        },
        {
          path: `nominee_details`,
          element: <NomineesPage />,
        },
        {
          path: `esign`,
          element: <NomineeUpdateEsign />,
        },
        {
          path: `esignResponse/*`,
          element: <NomineeEsignSuccessPage />,
        },
        {
          path: `completed`,
          element: <NomineeUpdationCompleted />,
        },
        {
          path: `approved`,
          element: <NomineeUpdationApproved />,
        },
      ],
    },
    //---------------------------------------Segment Update----------------------------
    {
      path: "segmentUpdate",
      element: "",
      children: [
        { element: <Navigate to="profile" />, index: true },
        {
          path: `profile`,
          element: <SegmentUpdateProfileDetails />,
        },
        {
          path: `segment_details`,
          element: <SegmentDetails />,
        },
        {
          path: `upload_documents`,
          element: <SegmentUploadDocumentsPage />,
        },
        {
          path: `esign`,
          element: <SegmentUpdateEsign />,
        },
        {
          path: `esignResponse/*`,
          element: <SegmentEsignSuccessPage />,
        },
        {
          path: `account_aggregator/*`,
          element: <SegmentUploadIncomeFetchResponse />,
        },
        {
          path: `completed`,
          element: <SegmentUpdationCompleted />,
        },
        {
          path: `approved`,
          element: <SegmentUpdationApproved />,
        },
      ],
    },
    //---------------------------------------DDPI Update----------------------------
    {
      path: "ddpi",
      element: "",
      children: [
        { element: <Navigate to="profile" />, index: true },
        {
          path: `profile`,
          element: <DDPIProfileDetails />,
        },
        {
          path: `esignResponse/*`,
          element: <SuccessDDPIEsignPage />,
        },
        {
          path: `esign`,
          element: <DDPIEsign />,
        },
        {
          path: `completed`,
          element: <DDPICompleted />,
        },
      ],
    },
    //---------------------------------------Fin Update----------------------------
    {
      path: "finupdate",
      element: "",
      children: [
        { element: <Navigate to="profile" />, index: true },
        {
          path: `profile`,
          element: <Profile />,
        },
        {
          path: `documents_upload`,
          element: <UploadDocumentsPageFinUpdate />,
        },
        {
          path: `account_aggregator/*`,
          element: <FinUpdateFetchIncomeResponse />,
        },
        {
          path: `completed`,
          element: <FinUpdationCompleted />,
        },
        {
          path: `up_to_date`,
          element: <FinUpdationApproved />,
        },
      ],
    },
    //---------------------------------------Account Closure----------------------------
    {
      path: "account_closure",
      element: "",
      children: [
        { element: <Navigate to="profiledetails" />, index: true },
        {
          path: `profiledetails`,
          element: <AccountClosureProfile />,
        },
        {
          path: `cmr_upload`,
          element: <AccountClosureCMRUpload />,
        },
        {
          path: `add_fund`,
          element: <AccountClosureAddFunds />,
        },
        {
          path: `account_settlement`,
          element: <AccountClosureSettlement />,
        },
        {
          path: `completed`,
          element: <AccountClosureApproved />,
        },
        {
          path: `esign`,
          element: <AccountClosureEsign />,
        },
        {
          path: `esignResponse/*`,
          element: <AccountClosureEsignSuccessPage />,
        },
      ],
    },
    {
      path: "/*",
      element: <PageNotFound />,
    },
    {
      path: "/callback/bankupdate/esign/*",
      element: <BankUpdateEsignSuccessPage />,
    },
  ]);

  return routes;
}
